import { render } from "./TopCreateRoomWindow.vue?vue&type=template&id=25c58177&scoped=true&ts=true"
import script from "./TopCreateRoomWindow.vue?vue&type=script&lang=ts"
export * from "./TopCreateRoomWindow.vue?vue&type=script&lang=ts"

import "./TopCreateRoomWindow.vue?vue&type=style&index=0&id=25c58177&scoped=true&lang=css"

import exportComponent from "/home/runner/work/owt/owt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25c58177"]])

export default __exports__